const initialState = { 
  loading: false,
  payload: [],
  error: null
}

function contactReducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_CONTACT_BEGIN':
      return {
        ...state,
        loading: true,
        error: null
      }

    case 'GET_CONTACT_SUCCESS':
      return {
        ...state,
        loading: false,
        payload: action.payload
      }

    case 'GET_CONTACT_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default contactReducer